/**
 * Cookie utilities for managing shared state across subdomains
 */

/**
 * Get the root domain for setting shared cookies
 * @returns {string} The domain to use for the cookie
 */
const getCookieDomain = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('pfadfinder-wutoeschingen.org')) {
        return '.pfadfinder-wutoeschingen.org';
    }
    // For local development (localhost, 127.0.0.1), don't set a domain
    // so it defaults to the current host.
    return '';
};

/**
 * Set a cookie
 * @param {string} name Cookie name
 * @param {string} value Cookie value
 * @param {number} days Days until expiration
 */
export const setCookie = (name, value, days = 365) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    const domain = getCookieDomain();
    const domainString = domain ? "; domain=" + domain : "";
    document.cookie = name + "=" + (value || "") + expires + domainString + "; path=/; SameSite=Lax";
};

/**
 * Get a cookie by name
 * @param {string} name Cookie name
 * @returns {string|null} Cookie value or null
 */
export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
